<template>
  <div class="wrap">
     
     <div class="leftdiv">
         <div>
             <p><span>智能匹配</span><span>高效辅助学习</span></p>
             <p>Intelligent matching efficient learning</p>
         </div>
         <img src="../../assets/hklogin/bg.png" />
         
     </div>
     <div class="rightdiv">
         <div class="loginbox">
             <div class="loginlogo">
                 <div>
                     <img src="../../assets/hklogin/logo.png" />
                 </div>
                 <div>
                     <p>奔鹿AI</p>
                     <p>BENLU AI</p>
                 </div>
                 
             </div>
             <div class="logintitle">欢迎回来，登陆系统开启美好的学习旅程！</div>
             <div class="loginform">
                 <div>
                     <span>用户名</span>
                     <p>
                         <img src="../../assets/hklogin/person@2x.png" />
                         <input ref="username" :class="usernameflag?'show':''" v-model="ruleForm.username" placeholder="请输入登录名" @focus="usernameflag=true" @blur="usernameflag=false" />
                     </p>
                 </div>

                  <div>
                     <span>登录密码</span>
                     <p>
                         <img src="../../assets/hklogin/lock@2x.png" />
                         <input ref="password" :class="passwordflag?'show':''" type="password" v-model="ruleForm.password"  placeholder="请输入登录密码" @focus="passwordflag=true" @blur="passwordflag=false" />
                     </p>
                 </div>
                 <div class="loginbtn" @click="login">
                     立即登录
                 </div>

             </div>
         </div>

         <div class="banquan">
             版权所有 © 2010-2021 Freepik Company SL版权所有。
         </div>
     </div>
  </div>
</template>
<script>
import { login } from "../../api/base";
export default {
  data() {
    return {
      imgpath: ``,
      ruleForm: {
        username: "",
        password: "",
        checkcode: "",
        ip: "",
        hidecode: true
      },
      usernameflag:false,
      passwordflag:false
    };
  },
  created() {
    let url = window.location.href;

    //
      this.utils.sessionSet("hklogin",1);

    this.ip = Math.random();
     
    if (this.utils.sessionGet("userinfo")) {
      this.$router.push({ path: "/index" });
      return false;
      // this.utils.storageRemove("userinfo");
    }

    let code = this.$route.query.hidecode;
    let storeCode = this.utils.sessionGet("hidecode");
    console.log("storeCode:" + storeCode);
    if (code) {
      this.ruleForm.hidecode = true;
      this.utils.sessionSet("hidecode", code);
    } else {
      if (storeCode) {
        this.ruleForm.hidecode = true;
        this.utils.sessionSet("hidecode", code);
        console.log("hidecode:" + this.ruleForm.hidecode);
      }
    }
    
    if (this.utils.sessionGet("userinfo")) {
      this.$router.push({ path: "/index" });
      return false;
      // this.utils.storageRemove("userinfo");
    }

    this.utils.sessionSet("chaoshi", 0);
    this.utils.storageClear();
  },
  methods: {
    login() {
      var that = this;

    if(that.ruleForm.username == ""){
        this.$refs.username.focus()
        return ;
    }

    if(that.ruleForm.password == ""){
        this.$refs.password.focus()
        return ;
    }

      login({
            username: that.ruleForm.username,
            password: that.ruleForm.password,
            checkcode: that.ruleForm.checkcode,
            ip: that.ip,
            hidecode: true
          }).then(res => {
            res.pwd = "";
            that.utils.storageSet("userinfo", res);
            that.utils.storageSet("usermessage", res);
            that.utils.sessionSet("userinfo", res);
            that.$router.push({ path: "/index" });

            this.utils.sessionSet("hklogin",1);
            
          });
    },
    
  },
  mounted() {},
  components: {}
};
</script>
<style scoped>
.wrap{
    background: #F7F6FB;
}
.wrap >div{
    width: 50%;
    display: inline-block;
    height: 100vh;
}

.wrap > div.rightdiv{
        background: #fff;
    border-bottom-left-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
}

.wrap >div.leftdiv >img{
        position: absolute;
    right: 50vw;
    margin-right: -0.5rem;
    width: 8rem;
    top: 1.6rem;
}

.wrap >div.leftdiv>div{
    position: absolute;
    left:1rem;
    top:1.2rem;
}

.wrap >div.leftdiv>div >p>span{
    font-size: 0.2rem;
    font-weight: 600;
    color: #34365D;
    margin-right: 0.3rem;
}

.wrap >div.leftdiv >div >p>span:last-child{
    color: #08B681;
}

.wrap >div.leftdiv>div>p:last-child{
    color: #34365D;
    font-size: 0.2rem;
    margin-top: 0.1rem;
}

.loginbox{
    width: 40vw;
    margin-left: 5vw;
    position: absolute;
    margin-top: 1.5rem;
}

.loginbox .loginlogo>div{
    width: 50%;
    display: inline-block;
    text-align: right;
}

.loginbox .loginlogo>div:last-child{
    text-align: left;
    line-height: 0.7rem;
    height: 0.7rem;
    vertical-align: bottom;
}

.loginbox .loginlogo>div:last-child >p{
    line-height: 0.30rem;
    height: 0.30rem;
    margin-left: 0.1rem;
}

.loginbox .loginlogo>div:last-child >p{
    color: #34365D;
    font-size: 0.24rem;
    font-weight: 600;
}

.loginbox .loginlogo>div:last-child >p:first-child{
    margin-top: 0.05rem;
}

.loginbox .loginlogo>div:last-child >p:last-child{
    color: #9FA0B4;
    font-size: 0.16rem;
    font-weight: 400;
    vertical-align: text-top;
}

.loginbox .loginlogo>div img{
    width: 0.7rem;
    height: 0.7rem;
    margin-right: 0.1rem;
}

.logintitle{
    text-align: center;
    font-size: 0.26rem;
    color: #34365D;
    margin-top: 0.2rem;
    font-weight: 400;
    margin-bottom: 0.3rem;
}

.loginform >div span{
        color: #34365D;
    font-size: 0.18rem;
    font-weight: bold;
    margin-bottom: 0.1rem;
    display: inline-block;
}

.loginform >div input{
    width: calc(100% - 0.6rem);
    border: 1px solid #D9E1EC;
    border-radius: 0.12rem;
    height: 0.72rem;
    line-height: 0.72rem;
    font-size: 0.2rem;
    padding-left: 0.6rem;
     
    
}

.loginform > div img{
    width: 0.35rem;
    height: 0.35rem;
    position: absolute;
    margin-left: 0.15rem;
    margin-top: 0.15rem;
}

.loginform >div{
    margin-bottom: 0.3rem;
}

.loginbtn{
    background: #08B681;
    color: #fff;
    font-weight: 600;
    text-align: center;
    font-size: 0.26rem;
    height: 0.72rem;
    line-height: 0.72rem;
    border-radius: 12px;
    cursor: pointer;
}

.loginbtn:hover{
    opacity: 0.8;
}

.banquan{
    color: #9FA0B4;
    font-size: 0.12rem;
    text-align: center;
    position:absolute;
    width: 50vw;
    bottom: 0.2rem;
    display: none;
}

input.show{
    border: #08B681 1px solid !important;
}
</style>